import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPlugin2"><Path d="M4 5.25C4 4.00736 5.00736 3 6.25 3H8.75C9.99264 3 11 4.00736 11 5.25V7H4V5.25Z" fill="currentColor"/><Path d="M13 5.25C13 4.00736 14.0074 3 15.25 3H17.75C18.9926 3 20 4.00736 20 5.25V7H13V5.25Z" fill="currentColor"/><Path d="M2 11.25C2 9.73122 3.23122 8.5 4.75 8.5H19.25C20.7688 8.5 22 9.73122 22 11.25V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin2;
